var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-slide-item",
    [
      _c(
        "v-chip",
        {
          staticClass: "detail-chip-tag mr-1",
          style: `color: ${_vm.invertColor(_vm.tagInfo.color)};`,
          attrs: { color: _vm.tagInfo.color, variant: "elevated", label: "" },
        },
        [_vm._v(" " + _vm._s(_vm.tagInfo.title) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }